<template>

  <div id="item-options-revised">

    <div class="close-box" @click="exit()" v-if="subMenuSelected() === false">
      <img src="../assets/closedialogue.svg" />
    </div>

    <div class="items-selected-list" v-if="selected_items.length > 0">

      <div class="selected-items-container">

        <div v-for="selected_item in selected_item_details" :key="selected_item.id" class="selected-item">
          {{ selected_item['translation_' + language] || selected_item.translation_en || selected_item.name }}
        </div>

      </div>

      <div class="explainer-text-small" v-if="selected_items.length > 1">Changes will apply to all selected items</div>

    </div>

    <div class="buttons-container" v-if="subMenuSelected() === false && show_more_options === false">

      <div class="button" v-for="button in computedButtons()" :key="button.name" @click="handleEvent(button.name)">

        <img :src="require(`../assets/${button.imgUrl}`)" v-if="button.imgUrl != undefined" />

        <p>{{ button.name }}</p>

      </div>

    </div>

    <div class="extra-options" v-if="show_more_options === true">

      <p class="custom-styles-note" v-if="customStylesOn()">
        Custom styles are on for {{ selected_items.length > 1 ? 'some of these items' : 'this item' }}, so the regular style settings (colour palette, fonts and alignment) are hidden.
        <span>Turn custom styles off to use them instead.</span>
      </p>

      <p class="option-group-title">Layout</p>
      <div class="option-grid">
        <div class="option-tile" @click="toggleAlignment('left')" v-if="!customStylesOn()">
          <i class="pi pi-align-left"></i>
          <p>Align left</p>
        </div>

        <div class="option-tile" @click="toggleAlignment('centre')" v-if="!customStylesOn()">
          <i class="pi pi-align-center"></i>
          <p>Align centre</p>
        </div>

        <div class="option-tile" @click="relocateMultipleItems()">
          <i class="pi pi-sort"></i>
          <p>Bulk sort items</p>
        </div>

        <div class="option-tile" @click="copyItemsToOtherMenu()">
          <i class="pi pi-copy"></i>
          <p>Copy items</p>
        </div>
      </div>

      <!-- detected (AI import) styles -->
      <template>
        <p class="option-group-title">Custom styles</p>
        <div class="option-grid">
          <div class="option-tile" :class="{ 'option-tile-active': customStylesOn() }" @click="setCustomStyles(!customStylesOn())">
            <i :class="customStylesOn() ? 'pi pi-eraser' : 'pi pi-palette'"></i>
            <p>{{ customStylesOn() ? 'Turn custom styles off' : 'Turn custom styles on' }}</p>
          </div>

          <div class="option-tile" v-if="customStylesOn()" @click="openCustomStylesEditor()">
            <i class="pi pi-pencil"></i>
            <p>Edit custom styles</p>
          </div>

          <div class="option-tile" @click="setCustomStylesForMenu(true)">
            <i class="pi pi-th-large"></i>
            <p>On for all items</p>
          </div>

          <div class="option-tile" @click="setCustomStylesForMenu(false)">
            <i class="pi pi-ban"></i>
            <p>Off for all items</p>
          </div>
        </div>

        <!-- only while custom styles are on: the price layout is part of the custom styles -->
        <template v-if="customStylesOn()">
          <p class="option-group-title">Price position</p>
          <div class="option-grid">
            <div class="option-tile" v-for="position in price_positions" :key="position.value"
              :class="{ 'option-tile-active': currentPricePosition() === position.value }" @click="setPricePosition(position.value)">
              <i :class="position.icon"></i>
              <p>{{ position.label }}</p>
            </div>
          </div>
        </template>
      </template>
    </div>

    <CopyItemsToOtherMenuModal v-if="copy_items_to_other_menu === true" :selected_items="selected_items"
      v-on:close="closeModal()" />

    <div class="more-options" v-if="custom_styles_editor_selected === false" @click="show_more_options = !show_more_options">{{ moreOptionsText() }}<span
        class="new-identifier"
        v-if="show_more_options === false && colour_palette_selected == false && fonts_selected == false && modifiers_selected == false && image_uploader_selected == false">New!</span>
    </div>

    <ColourPalette v-if="colour_palette_selected === true" :selected_items="selected_items" :menu="menu"
      :selected_item_details="selected_item_details" v-on:return-to-buttons="returnToButtons()"
      v-on:items-updated="itemsUpdated" />

    <Fonts v-if="fonts_selected === true" :selected_items="selected_items" :menu="menu"
      :selected_item_details="selected_item_details" v-on:return-to-buttons="returnToButtons()"
      v-on:items-updated="itemsUpdated" />

    <CustomStylesEditor v-if="custom_styles_editor_selected === true" :selected_item_details="selected_item_details" :menu="menu"
      v-on:return-to-buttons="returnToButtons()" v-on:items-updated="itemsUpdated" />

    <ImageUploadPage v-if="image_uploader_selected === true" :selected_items="selected_items" :menu="menu"
      :selected_item_details="selected_item_details" v-on:return-to-buttons="returnToButtons()"
      v-on:items-updated="itemsUpdated" />

  </div>


</template>

<script>
import ColourPalette from '@/components/ColourPalette.vue'
import Fonts from '@/components/Fonts.vue'
import ImageUploadPage from '@/components/ImageUploadPage.vue'
import ItemAlignment from '@/components/dynamic_svgs/ItemAlignment.vue'
import CopyItemsToOtherMenuModal from './CopyItemsToOtherMenuModal.vue'
import CustomStylesEditor from '@/components/ai/CustomStylesEditor.vue'

// Regular style settings, hidden while an item's custom (detected) styles are on.
const STYLE_BUTTONS = ['Colour palette', 'Fonts']

export default {
  name: 'ItemOptionsRevised',
  props: ['selected_items', 'foods', 'menu', 'languages', 'language', 'relocating_multiple_items'],
  components: {
    ColourPalette,
    Fonts,
    ImageUploadPage,
    ItemAlignment,
    CopyItemsToOtherMenuModal,
    CustomStylesEditor
  },
  data() {
    return {
      selected_item_details: [],
      colour_palette_selected: false,
      fonts_selected: false,
      modifiers_selected: false,
      image_uploader_selected: false,
      custom_styles_editor_selected: false,
      image: {},
      componentKey: 0,
      show_more_options: false,
      copy_items_to_other_menu: false,
      price_positions: [
        { value: 'left', label: 'Price left', icon: 'pi pi-align-left' },
        { value: 'middle', label: 'Price middle', icon: 'pi pi-align-center' },
        { value: 'right', label: 'Price right', icon: 'pi pi-align-right' }
      ],
      url: process.env.VUE_APP_API_URL,
      buttons: [
        {
          name: "Edit item",
          imgUrl: "edit-item.svg",
          method: "editItem()",
          onlyOneSelected: true
        },
        {
          name: "Colour palette",
          imgUrl: "colour-palette-button.svg",
          onlyOneSelected: false
        },
        {
          name: "Fonts",
          imgUrl: "fonts-button.svg",
          onlyOneSelected: false
        },
        {
          name: "Modifiers",
          imgUrl: "modifiers-button.svg",
          onlyOneSelected: true
        },
        {
          name: "Image",
          imgUrl: "image-button.svg",
          onlyOneSelected: true
        },
        {
          name: "Duplicate",
          imgUrl: "duplicate-button.svg",
          onlyOneSelected: true
        },
        {
          name: "Hide/Show",
          imgUrl: "visible-button.svg",
          onlyOneSelected: false
        },
        {
          name: "Delete",
          imgUrl: "delete-button.svg",
          onlyOneSelected: false
        },
      ]
    }
  },
  created() {
    this.retrieveSelectedItemDetails();
  },
  methods: {
    exit() {
      this.$emit('close');
    },
    closeModal() {
      this.copy_items_to_other_menu = false;
    },
    itemsUpdated: function (selected_item_details) {
      this.selected_item_details = selected_item_details
      this.$emit('item-updated-successfully', this.selected_item_details)
      this.selected_item_details = JSON.parse(selected_item_details)
    },
    moreOptionsText() {
      if (this.show_more_options === true) {
        return 'Back'
      } else {
        if (this.colour_palette_selected == false && this.fonts_selected == false && this.modifiers_selected == false && this.image_uploader_selected == false) {
          return "Alignment & bulk sorting"
        }
      }
    },
    relocateMultipleItems() {
      this.$emit('relocate-multiple-items')
    },
    copyItemsToOtherMenu() {
      console.log('copy items to other menu firing from item options revised')
      console.log(`selected items: ${this.selected_items}`)
      this.copy_items_to_other_menu = true;
      // this.$emit('copy-items-to-other-menu')
    },
    toggleAlignment(direction) {
      console.log("TOGGLE ALIGNMENT FIRED")
      let selected_direction = Boolean
      if (direction === 'left') {
        selected_direction = false
      }
      if (direction === 'centre') {
        selected_direction = true
      }
      var selected_items = this.selected_items
      this.$emit('set-to-loading')
      for (let i = 0; i < selected_items.length; i++) {
        console.log(selected_direction)
        this.$http.secured.post(`/app_update_food/` + this.menu.id + '/' + selected_items[i], {
          food: {
            centre_content: selected_direction
          }
        })
          .then(response => {
            console.log(response.data)
            this.selected_item_details[i].centre_content = selected_direction
            this.selected_item_details[0].centre_content = selected_direction
            this.$emit('item-updated-successfully', JSON.stringify(this.selected_item_details[i]))
            this.componentKey++
          })
          .catch(error => this.setError(error, 'Cannot update food.'))
      }
    },
    setError(error, text) {
      console.error(error)
      alert((error.response && error.response.data && error.response.data.error) || text)
    },
    // True when any selected item has its custom (detected) styles on.
    customStylesOn() {
      return this.selected_item_details.some(item => item.custom_css_styles === true)
    },
    // Turns the detected custom CSS styles on or off for the selected items (their stored CSS is kept).
    setCustomStyles(enabled) {
      this.$emit('set-to-loading')
      this.selected_items.forEach(food_id => {
        this.$http.secured.post(`/app_update_food/${this.menu.id}/${food_id}`, { food: { custom_css_styles: enabled } })
          .then(() => {
            const item = this.selected_item_details.find(detail => detail.id === food_id)
            if (item) {
              item.custom_css_styles = enabled
              this.$emit('item-updated-successfully', JSON.stringify(item))
            }
          })
          .catch(error => this.setError(error, 'Cannot update food.'))
      })
    },
    // The selected items' price position when they all share one (null when mixed or unset).
    currentPricePosition() {
      const positions = [...new Set(this.selected_item_details.map(item => item.custom_price_position || null))]
      return positions.length === 1 ? positions[0] : null
    },
    setPricePosition(position) {
      this.selected_items.forEach(food_id => {
        this.$http.secured.post(`/app_update_food/${this.menu.id}/${food_id}`, { food: { custom_price_position: position } })
          .then(() => {
            const item = this.selected_item_details.find(detail => detail.id === food_id)
            if (item) {
              item.custom_price_position = position
              this.$emit('item-updated-successfully', JSON.stringify(item))
            }
          })
          .catch(error => this.setError(error, 'Cannot update the price position.'))
      })
    },
    // Same for every item on the menu, then reloads so every item re-renders.
    setCustomStylesForMenu(enabled) {
      const message = enabled
        ? 'Turn custom styles on for every item on this menu? Items without detected styles won\'t change.'
        : 'Turn custom styles off for every item on this menu? The styles are kept and can be turned back on.'
      if (!confirm(message)) {
        return
      }
      this.$http.secured.post(`/app_custom_css_styles/${this.menu.id}`, { enabled })
        .then(() => window.location.reload())
        .catch(error => this.setError(error, 'Cannot update the menu styles.'))
    },
    handleEvent(button_name) {
      if (button_name === "Edit item") {
        this.editItem();
      }
      if (button_name === "Duplicate") {
        this.cloneItem();
      }
      if (button_name === "Delete") {
        this.deleteItem();
      }
      if (button_name === "Hide/Show") {
        this.toggleItemVisibility();
      }
      if (button_name === "Image") {
        this.image_uploader_selected = true
      }
      if (button_name === "Fonts") {
        this.fonts_selected = true
      }
      if (button_name === "Colour palette") {
        this.colour_palette_selected = true
      }
      if (button_name === "Modifiers") {
        window.location.replace(this.url + '/foods/' + this.selected_items[0] + '/add_selections');
      }
    },
    subMenuSelected() {
      if (this.colour_palette_selected === true || this.fonts_selected === true || this.image_uploader_selected === true || this.custom_styles_editor_selected === true) {
        return true
      } else {
        return false
      }
    },
    returnToButtons() {
      this.colour_palette_selected = false
      this.fonts_selected = false
      this.modifiers_selected = false
      this.image_uploader_selected = false
      this.custom_styles_editor_selected = false
    },
    openCustomStylesEditor() {
      this.show_more_options = false
      this.custom_styles_editor_selected = true
    },
    computedButtons() {
      // One path for styles: the regular style settings are hidden while custom styles are on.
      var buttons = this.customStylesOn() ? this.buttons.filter(button => !STYLE_BUTTONS.includes(button.name)) : this.buttons
      var computedButtons = []
      for (let i = 0; i < buttons.length; i++) {
        if (this.selected_items.length > 1) {
          if (buttons[i].onlyOneSelected != true) {
            computedButtons.push(buttons[i])
          }
        } else {
          computedButtons.push(buttons[i])
        }
      }
      return computedButtons
    },
    retrieveSelectedItemDetails() {
      console.log(`${this.selected_items}`)
      var selected_items = this.selected_items
      var foods = this.foods
      var selected_item_details = []
      for (let i = 0; i < foods.length; i++) {
        if (selected_items.includes(foods[i].id)) {
          selected_item_details.push(foods[i])
        }
      }
      this.selected_item_details = selected_item_details
    },
    editItem() {
      localStorage.snapToItem = `${this.selected_items[0]}`
      this.$store.commit("setAnchoredItem", this.selected_item_details[0].id);
      this.$emit('edit-item', this.selected_items[0])
      console.log(`emitted: ${this.selected_items[0]}`)
    },
    toggleItemVisibility() {
      var selected_items = this.selected_items
      var visibility_setting = this.selected_item_details[0].hidden
      this.$emit('set-to-loading')
      for (let i = 0; i < selected_items.length; i++) {
        this.$http.secured.post(`/app_update_food/` + this.menu.id + '/' + selected_items[i], {
          food: {
            hidden: !visibility_setting
          }
        })
          .then(response => {
            console.log(response.data)
            this.selected_item_details[i].hidden = !visibility_setting
            this.$emit('item-updated-successfully', JSON.stringify(this.selected_item_details))
          })
          .catch(error => this.setError(error, 'Cannot create food.'))
      }
    },
    deleteItem() {
      if (confirm(`Are you sure you want to delete all selected items? Number of items that will be deleted: ${this.selected_items.length}.`)) {
        this.$emit('set-to-loading');
        for (let i = 0; i < this.selected_items.length; i++) {
          this.$http.secured.delete("/app_food_destroy/" + this.selected_items[i])
            .then(response => {
              this.$emit('item-deleted', this.selected_items[i])
            })
            .catch(error => this.setError(error, 'Something went wrong'))
        }
      }
    },
    toggleImageSelector() {
      if (this.image_selector === false) {
        this.image_selector = true
      } else {
        this.image_selector = false
      }
    },
    cloneItem() {
      const value = this.selected_item_details[0]
      this.$emit('set-to-loading');
      this.$store.commit("setAnchoredItem", this.selected_item_details[0].id);
      const self = this;
      var font = ''
      if (this.$store.getters.getSelectedFont != '') {
        font = this.$store.getters.getSelectedFont
      } else {
        font = 'default'
      }

      if (!value) {
        return
      }
      this.$http.secured.post(`/app_clone_food/` + this.selected_item_details[0].id, {
        food: {
          translation_en: this.selected_item_details[0].translation_en,
          translation_ru: this.selected_item_details[0].translation_ru,
          translation_jp: this.selected_item_details[0].translation_jp,
          translation_sp: this.selected_item_details[0].translation_sp,
          translation_fr: this.selected_item_details[0].translation_fr,
          translation_ca: this.selected_item_details[0].translation_ca,
          translation_kr: this.selected_item_details[0].translation_kr,
          translation_de: this.selected_item_details[0].translation_de,
          translation_zh: this.selected_item_details[0].translation_zh,
          translation_nl: this.selected_item_details[0].translation_nl,
          translation_pt: this.selected_item_details[0].translation_pt,
          translation_it: this.selected_item_details[0].translation_it,
          translation_ar: this.selected_item_details[0].translation_ar,
          description_en: this.selected_item_details[0].description_en,
          description_ru: this.selected_item_details[0].description_ru,
          description_jp: this.selected_item_details[0].description_jp,
          description_sp: this.selected_item_details[0].description_sp,
          description_fr: this.selected_item_details[0].description_fr,
          description_ca: this.selected_item_details[0].description_ca,
          description_kr: this.selected_item_details[0].description_kr,
          description_de: this.selected_item_details[0].description_de,
          description_zh: this.selected_item_details[0].description_zh,
          description_nl: this.selected_item_details[0].description_nl,
          description_pt: this.selected_item_details[0].description_pt,
          description_it: this.selected_item_details[0].description_it,
          description_ar: this.selected_item_details[0].description_ar,
          category_header: this.selected_item_details[0].category_header,
          major_category_header: this.selected_item_details[0].major_category_header,
          unit: this.selected_item_details[0].unit,
          price: this.selected_item_details[0].price,
          second_price_number: this.selected_item_details[0].second_price_number,
          third_price_number: this.selected_item_details[0].third_price_number,
          second_unit: this.selected_item_details[0].second_unit,
          third_unit: this.selected_item_details[0].third_unit,
          special_tag_for_item: this.selected_item_details[0].special_tag_for_item,
          orderable: this.orderable,
          spicy: this.selected_item_details[0].spicy,
          vegan: this.selected_item_details[0].vegan,
          spicy_level_two: this.selected_item_details[0].spicy_level_two,
          spicy_level_three: this.selected_item_details[0].spicy_level_three,
          chef_recommended: this.selected_item_details[0].chef_recommended,
          pork: this.selected_item_details[0].pork,
          vegetarian: this.selected_item_details[0].vegetarian,
          halal: this.selected_item_details[0].halal,
          dairy: this.selected_item_details[0].dairy,
          fish: this.selected_item_details[0].fish,
          alcohol: this.selected_item_details[0].alcohol,
          alcohol_free: this.selected_item_details[0].alcohol_free,
          gluten: this.selected_item_details[0].gluten,
          gluten_free: this.selected_item_details[0].gluten_free,
          peanuts: this.selected_item_details[0].peanuts,
          shellfish: this.selected_item_details[0].shellfish,
          egg: this.selected_item_details[0].egg,
          twenty_four_hours: this.selected_item_details[0].twenty_four_hours,
          soy_beans: this.selected_item_details[0].soy_beans,
          walnuts: this.selected_item_details[0].walnuts,
          celery: this.selected_item_details[0].celery,
          mustard: this.selected_item_details[0].mustard,
          sesame_seeds: this.selected_item_details[0].sesame_seeds,
          sulfites: this.selected_item_details[0].sulfites,
          lupin: this.selected_item_details[0].lupin,
          clams: this.selected_item_details[0].clams,
          menu_id: this.menu.id,
          item_name_font: this.selected_item_details[0].item_name_font,
          item_price_font: this.selected_item_details[0].item_price_font,
          item_name_font_colour: this.selected_item_details[0].item_name_font_colour,
          item_description_font: this.selected_item_details[0].item_description_font,
          background_colour: this.selected_item_details[0].background_colour,
          stroke_bottom: this.selected_item_details[0].stroke_bottom,
          sort: this.selected_item_details[0].sort,
          item_name_font_size: this.selected_item_details[0].item_name_font_size,
          container_height: this.selected_item_details[0].container_height,
          item_type: 'food'
        }
      })
        .then(response => {
          // this.$emit('item-cloned-successfully', JSON.stringify(this.selected_item_details))
          this.$emit('reload-menu')
        }).catch(error => this.setError(error, 'Cannot create food.'))
    }
  },
  watch: {
    selected_items() {
      this.retrieveSelectedItemDetails();
    },
    foods() {
      this.retrieveSelectedItemDetails();
    }
  }
}





</script>

<style scoped>
#item-options-revised {
  position: fixed;
  bottom: 0;
  z-index: 1000;
  background-color: white;
  width: 95%;
  max-width: 750px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 20px 0px 20px 0px;
  border-radius: 10px 10px 0px 0px;
}

.buttons-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-start; /* each button is 25% wide; a short last row stays packed to the left */
}

.button {
  display: flex;
  flex-direction: column;
  width: 25%;
  align-items: center;
  color: #505050;
  font-weight: 600;
  box-sizing: border-box;
  padding: 10px 5px 10px 5px;
  cursor: pointer;
  margin-top: 10px;
}

.button:hover {
  background-color: #B3CBE7;
  transition: 0.2s;
}

.button img {
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}

.button p {
  text-align: center;
  margin: 0px 0px 0px 0px;
}

.close-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  cursor: pointer;
}

.close-box img {
  width: 20px;
  height: 20px;
  margin-bottom: 25px;
}

.items-selected-list {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 0px 10px 0px 10px;
}

.selected-items-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin: 10px 0px 10px 0px;
}

.selected-item {
  background-color: #8CC63E;
  color: white;
  box-sizing: border-box;
  padding: 2.5px 5px 2.5px 5px;
  margin-right: 5px;
  border-radius: 2.5px;
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 2.5px;
  margin-top: 2.5px;
}

.explainer-text {
  font-weight: 600;
  font-size: 12.5px;
}

.explainer-text-small {
  font-size: 10px;
  font-weight: 400;
  color: #505050;
}

.more-options {
  margin: auto;
  width: 100%;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 25px;
  text-transform: uppercase;
  letter-spacing: 0.25px;
  color: #404041;
  position: relative;
}

.new-identifier {
  position: absolute;
  top: -17px;
  background-color: #EDD15D;
  border: 1px solid #B3A259;
  color: black;
  width: max-content;
  font-size: 10px;
  box-sizing: border-box;
  padding: 2.5px;
  border-radius: 2.5px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}

.alignment-options {
  font-size: 10px;
  font-weight: 400;
  color: black;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 10px;
}

.relocation-options {
  margin-left: 50px;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.relocation-options:hover {
  background-color: #B3CBE7;
  transition: 0.2s;
}

.copy-options {
  cursor: pointer;
}

.sort-button-container {
  width: 50px;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: rgba(100, 100, 100, 0.7);
  margin: auto;
}

.alignment-buttons-container {
  display: flex;
  flex-direction: row;
  width: 125px;
  justify-content: space-between;
}

.alignment-tag {
  color: #505050;
  font-weight: 600;
}

.extra-options {
  width: 100%;
  box-sizing: border-box;
  padding: 30px 20px 0px 20px;
}

.option-group-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: dimgray;
  margin: 0px 0px 8px 0px;
}

.option-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 25px;
}

.option-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
  min-height: 90px;
  padding: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}

.option-tile:hover {
  border-color: black;
}

.option-tile i {
  font-size: 22px;
  color: black;
}

.option-tile p {
  font-size: 12px;
  margin: 8px 0px 0px 0px;
}

.option-tile-active {
  background-color: rgba(39, 170, 225, 0.1);
  border-color: rgba(39, 170, 225, 1);
}

.custom-styles-note {
  font-size: 12px;
  background-color: #f7f7f7;
  border-radius: 8px;
  padding: 10px 12px;
  margin: 0px 0px 20px 0px;
}

@media(max-width: 600px) {
  .option-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media(max-width: 600px) {
  .button p {
    font-size: 12.5px;
  }
}
</style>